import { api } from './api';

class CustomerQrService {
    /** Shared customer portal URL (one QR for all customers — mobile OTP login on rsa-customer). */
    async getPortal() {
        return api.get('/api/auth/customer/qr/portal');
    }

    /** Alias of getPortal — POST kept for backward compatibility with older admin builds. */
    async generate() {
        return api.post('/api/auth/customer/qr/generate', {});
    }
}

export const customerQrService = new CustomerQrService();
